import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'form-view',
  templateUrl: './form-view.component.html',
  styleUrls: ['./form-view.component.scss']
})
export class FormViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
